<template>
  <div v-text="text" />
</template>

<script>
import VueTypes from "vue-types";

export default {
  props: {
      difference: VueTypes.number.isRequired,
      riskIndex: VueTypes.number.isRequired,
      age: VueTypes.number.isRequired,
      sex: VueTypes.string.isRequired
  },
  computed: {
    text: function() {
      if (this.riskIndex === 0) {
        if (this.difference <= 0) {
          return this.$i18n.t("aiPredictionReport.messageForNormal.healthier", {
            age: this.age,
            sex: this.sex
          });
        } else if (this.difference <= 10) {
          return this.$i18n.t(
            "aiPredictionReport.messageForNormal.slightlyHigherRisk",
            { age: this.age, sex: this.sex }
          );
        } else {
          return this.$i18n.t(
            "aiPredictionReport.messageForNormal.somewhatHigherRisk",
            { age: this.age, sex: this.sex }
          );
        }
      } else if (this.riskIndex === 1) {
        if (this.difference <= -30) {
          return this.$i18n.t(
            "aiPredictionReport.messageForCaution.somewhatHealthier",
            { age: this.age, sex: this.sex }
          );
        } else if (this.difference <= -10) {
          return this.$i18n.t(
            "aiPredictionReport.messageForCaution.slightlyHealthier",
            { age: this.age, sex: this.sex }
          );
        } else if (this.difference <= 10) {
          return this.$i18n.t(
            "aiPredictionReport.messageForHigher.shomewhatHigherRisk",
            { age: this.age, sex: this.sex }
          );
        } else if (this.difference <= 30) {
          return this.$i18n.t(
            "aiPredictionReport.messageForHigher.slightlyHigherRisk",
            { age: this.age, sex: this.sex }
          );
        } else {
          return this.$i18n.t(
            "aiPredictionReport.messageForHigher.farHigherRisk",
            { age: this.age, sex: this.sex }
          );
        }
      } else if (this.riskIndex === 2) {
        if (this.difference <= -30) {
          return this.$i18n.t(
            "aiPredictionReport.messageForRisk.farHealthier",
            { age: this.age, sex: this.sex }
          );
        } else if (this.difference <= -10) {
          return this.$i18n.t(
            "aiPredictionReport.messageForRisk.slightlyHealthier",
            { age: this.age, sex: this.sex }
          );
        } else if (this.difference <= 0) {
          return this.$i18n.t(
            "aiPredictionReport.messageForRisk.somewhatHealthier",
            { age: this.age, sex: this.sex }
          );
        } else if (this.difference <= 10) {
          return this.$i18n.t(
            "aiPredictionReport.messageForRisk.somewhatHigherRisk",
            { age: this.age, sex: this.sex }
          );
        } else if (this.difference <= 30) {
          return this.$i18n.t(
            "aiPredictionReport.messageForRisk.slightlyHigherRisk",
            { age: this.age, sex: this.sex }
          );
        } else {
          return this.$i18n.t(
            "aiPredictionReport.messageForRisk.farHigherRisk",
            { age: this.age, sex: this.sex }
          );
        }
      } else {
        return this.$i18n.t("aiPredictionReport.becauseYouCurrentlyBelongTo");
      }
    },
  }
};
</script>
